import React, { useContext, useEffect, useState } from "react";
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
// import Loading from '../../components/advance/Loading';
// import Modal from '../../components/advance/Modal';
// import Accordian from '../../components/core/Accordian';
import Button from "../../components/core/EPL_Button_Think";
// import ErrorModal from '../../modals/ErrorModal';
// import { UserContext } from '../../shared/context/UserContext';
// import useMediaQuery from '../../shared/hooks/useMediaQuery';
import CheckField from "../../components/form/CheckField";
import useMediaQuery from "../../hooks/useMediaQuery";
// import VendorService from '../../shared/services/VendorService';
// import poll from '../../shared/utils/poll';
// import sendRequest from '../../shared/utils/sendRequest';
// import { filterAddress, isValidAddress } from '../../shared/validations/Address';
// import { isValidCity } from '../../shared/validations/City';
// import { isValidMobileNumber } from '../../shared/validations/MobileNumber';
// import { filterName, isValidName } from '../../shared/validations/Name';
// import { isValidPincode } from '../../shared/validations/Pincode';
// import Progress from '../progress/Progress';
// import Summary from '../summary/Summary';
// import { AfterLoginLayoutWrapper } from "../_styles/AfterLoginLayoutWrapper";
import icon_modal from "../../assets/svg/EPL_think_svg/Icon_modal.svg";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import { UserContext } from "../../shared/context/UserContext";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import ScenarioBasedModal from "../other-pages/Modals/ScenarioBasedModal";
import { AdditionalDetailsWrapper } from "./_styles/AdditionalDetailsWrapper";
// import Dropdown from "../../components/core/Dropdown";
import SubTitle from "../../components/core/SubTitle";
// const getInternalStage = (stage, stage_status) => {
//   if (stage === 'ADDITIONAL_DETAILS' && stage_status === 'INIT') {
//     return 'ADDITIONAL_DETAILS_INIT';
//   } else if (stage === 'ADDITIONAL_DETAILS' && stage_status === 'COMPLETE') {
//     return 'ADDITIONAL_DETAILS_COMPLETE';
//   } else {
//     return 'ADDITIONAL_DETAILS_COMPLETE';
//   }
// };
import {
    CE_POLLING,
    UPDATE_ADDRESS
} from "../../Config";
import { encrypt } from "../../utils/crypto";
import { async } from "q";
import {
  GetCustomerDetailsContext,
  validateInputExistenece,
} from "../../App";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import poll from "../../utils/poll";
import sendRequest from "../../utils/sendRequest";
import { CePollingFailed } from "../other-pages/Modals/AllModal";
import { updateLead } from "../../shared/services/crm";
import { encryptedData } from "../../utils";

const UpsellVerifyDetails = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");

  const { user, setUser } = useContext(UserContext);
  // const applicationFormNumber = user.application_form_no;
  const [mobileNumber, setMobileNumber] = useState("");
  // const [internalStage, setInternalStage] = useState(
  //   getInternalStage(user.Stage.stage, user.Stage.stage_status)
  // );

  // const [activeAccordian, setActiveAccordian] = useState('current_address');

  // const [modal, setModal] = useState('');
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(false);
  const [loanAgreementConsent, setLoanAgreementConsent] = useState(false);
  const [additionalConfirm, setAdditionalConfirm] = useState("");
  const [aadharAddressConfirm, setAadharAddressConfirm] = useState("");
  const [okycCalled, setOkycCalled] = useState();
  // Current Address
  const [currentAddress, setCurrentAddress] = useState("");
  const [currentPincode, setCurrentPincode] = useState("");
  const [currentCity, setCurrentCity] = useState("");
  const [currentState, setCurrentState] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [cePollingFailed, setCePollingFailed] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [showShimmer, setShowShimmer] = useState(false);

  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("AdditionalDetails customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed

      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      // console.log("source: ", customerDetails.source);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    } else {
      // console.log("AdditionalDetails Ouch customerDetails ", location);
      // console.log("UseContext>>>>>>>>>>>>", customerDetails);
    }
  }, [customerDetails]);

  const handleOnSubmit = async () => {
    await checkCEStatus();
  };
  const [conditionalCheck, setConditionalCheck] = useState();

  const checkCEStatus = async () => {
    setShowShimmer(true);
    try {
      // console.log("Approved/Rejected");
      const { response } = await poll(
        async () =>
          await sendRequest("/" + customerDetails.source + CE_POLLING, {
            application_form_no: customerDetails.application_form_number,
          }),
        ({ response }) => response.Success
      );
      // console.log(response);
      if (response.Success) {
        if (response.Message === "SUCCESS_REJECTED") {
          updateLead(customerDetails.source, 77, customerDetails.application_form_number)
          setCePollingFailed(true);
        } else {
          await addressApi();
        }
      }
    } catch (error) {
      if(customerDetails.source === "upsell"){
        updateLead(customerDetails.source, 66, customerDetails.application_form_number)
      }
      /* Handle unexpected response */
      if (error.code === "ECONNABORTED") {
      } else {
        /* CRM Stage - E-Mandate Check Technical Failure */
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        setShowShimmer(false);
      }
    }
  };

  const addressApi = async () => {
    // console.log("loanPurpose: ", loanPurpose);
    // console.log("addressVerified: ", additionalConfirm);
    // setLoad(true);
    setShowShimmer(true);

    try {
      const formData1 = new FormData();
      const requestData1 = {
        application_form_no: customerDetails.application_form_number,
        full_address: currentAddress,
        pincode: currentPincode,
        city: currentCity,
        state: currentState,
        address_type: "UPSELL",
        verified: additionalConfirm,
        loan_purpose: "Others",
        current_stage: customerDetails.stage,
        stage_conditions: {
          address_verified: conditionalCheck,
        },
      };
      formData1.append("data", encryptedData(requestData1));
      try {
        // console.log("Inside try block");
        const { response } = await sendRequest(
          "/" + customerDetails.source + UPDATE_ADDRESS,
          formData1
        );
        // console.log(response);
        if (response.Success == true) {
          updateLead(customerDetails.source, 53, customerDetails.application_form_number)
          setCustomerDetails({
            ...customerDetails,
            stage: response.STAGE,
          });
        } else if(!response.Success && response.STAGE === "ADDRESS_REJECT") {
          /**
           * User is redirected to reject page if address validation fails
           */
          setCustomerDetails({
            ...customerDetails,
            stage: response.STAGE
          });
        }
      } catch (error) {
        if(customerDetails.source === "upsell"){
          updateLead(customerDetails.source, 66, customerDetails.application_form_number)
        }
        // console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        setShowShimmer(false);
      }
    } catch (error) {
      if(customerDetails.source === "upsell"){
        updateLead(customerDetails.source, 66, customerDetails.application_form_number)
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      // updateLead(17, decryptURL(search_params['account_id']));
    }
  };

  const updateLoanAgreementConsent = () => {
    setLoanAgreementConsent(!loanAgreementConsent);
    setOnSubmitButtonDisabled(!onSubmitButtonDisabled);
  };

  const [consentCheckbox, setConsentCheckbox] = useState(false);
  const [dataCaptured, setDataCaptured] = useState();

  // useEffect(async () => {
  //   console.log("INSIDE USEEFFECT OF ADDITIONAL");
  //   await GetCustomerDetails(
  //     customerDetails.application_form_number,
  //     customerDetails.source,
  //     customerDetails,
  //     setCustomerDetails
  //   );
  //   // setDataCaptured("Done");
  //   // window.scrollTo(0, 0);
  //   // setLoanPurposeOptions(createLoanPurposeOptions());
  // }, []);

  useEffect(async () => {
    // console.log(customerDetails);
    setCurrentAddress(customerDetails?.Data?.full_address);
    if (customerDetails?.Data?.resi_city){
      setCurrentCity(customerDetails?.Data?.resi_city);
    }
    if (customerDetails?.Data?.resi_state){
      setCurrentState(customerDetails?.Data?.resi_state);
    }
    if (customerDetails?.Data?.pincode){
      setCurrentPincode(customerDetails?.Data?.pincode);
    }
    setMobileNumber(customerDetails?.Data?.mobile);
  }, []);

  const loanPurposes = [
    "Asset Acquisition",
    "Balance Transfer",
    "Education Purpose",
    "Family Celebration",
    "Family settlement",
    "Health and Wellness",
    "Home Renovation",
    "Medical Expense",
    "Purchase of fixed assets",
    "Vacation",
    "Others",
  ];

  const createLoanPurposeOptions = (isFilter = false, filterText = "") => {
    const options = [];
    // console.log("Creating Loan Purpose Options");
    for (let i = 0; i < loanPurposes.length; i++) {
      if (
        isFilter &&
        loanPurposes[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: loanPurposes[i],
          value: loanPurposes[i],
          func: () => {
            setLoanPurpose(loanPurposes[i]);
            showDropdown();
          },
        });
      } else if (!isFilter) {
        options.push({
          label: loanPurposes[i],
          value: loanPurposes[i],
          func: () => {
            setLoanPurpose(loanPurposes[i]);
            showDropdown();
          },
        });
      }
    }
    if (options.length === 0) {
      options.push({
        label: "Not Found",
        value: "Not Found",
        func: () => {
          filterText = "";
          isFilter = false;
          setLoanPurpose("");
          showDropdown();
        },
      });
    }

    // console.log("Loan Purpose Options Created");
    return options;
  };

  const [loanPurposeOptions, setLoanPurposeOptions] = useState([]);

  const [loanPurpose, setLoanPurpose] = useState();
  const [loanPurposePlaceholder, setLoanPurposePlaceholder] =
    useState("Purpose of Loan");
  var defaultLoanPurposePlaceholderStyle = {
    position: "absolute",
    width: "max-content",
    left: "0.75em",
    top: "50%",
    padding: "0px 0.25em",
    transform: "translateY(-50%)",
    color: "#717171", // var(--color-bw_black);
    border: "none",
    borderRadius: "2px",
    fontSize: "20px",
    pointerEvents: "none",
    transition: "all 0.3s ease",
  };
  const [loanPurposePlaceholderStyle, setLoanPurposePlaceholderStyle] =
    useState(defaultLoanPurposePlaceholderStyle);

  const loanPurposeDropdown = (filterText) => {
    setLoanPurpose(filterText);
    // setLoanPurposeOptions(createLoanPurposeOptions(true, filterText));
  };

  const loanPurposeFocus = (event) => {
    // console.log("EVENT: ", event);
    // setLoanPurposePlaceholder("");
    var focusStyle = {
      top: "-0.5em",
      left: "0.25em",
      fontSize: "16px",
    };
    setLoanPurposePlaceholderStyle(focusStyle);
  };

  const loanPurposeBlur = (event) => {
    setLoanPurposePlaceholderStyle(defaultLoanPurposePlaceholderStyle);
  };

  const showDropdown = () => {
    document.getElementById("myDropdown").classList.toggle("show");
  };

  const allFieldsVerified = () => {
    return confirmedAddress() && consentCheckbox;
  };

  const confirmedAddress = () => {
    if (additionalConfirm === "Yes" || additionalConfirm === "No") return true;
    return false;
  };

  const updateAdditionalConfirm = (e) => {
    if (e.target.value === "Yes") {
      setConditionalCheck(true);
    } else {
      setConditionalCheck(false);
    }
    setAdditionalConfirm(e.target.value);
    setAadharAddressConfirm("");
  };

  const updateAadharAddressConfirm = (e) => {
    // console.log("hiii");
    if (e.target.value == "Yes") {
      setShowModal(true);
    }
    setAadharAddressConfirm(e.target.value);
  };

  return (
    <>
      <ProgressBar showProgress={true} currentStep={4} showText={false} />
      <CePollingFailed
        isOpen={cePollingFailed}
        onClose={() => {
          setCePollingFailed(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <AfterLoginLayoutWrapper>
        <ScenarioBasedModal
          id="bd-modal"
          modalImage={icon_modal}
          isOpen={showModal}
          showCloseButton={false}
          onClose={() => {
            setShowModal(false);
          }}
          modalMessageHeading={"Hello " + customerDetails?.Data?.first_name}
          modalMessage="Please keep your AADHAR ready to proceed with your application for completing KYC"
          modalSubmitMessage="Click to Proceed"
          style={{ borderRadius: "20px" }}
          onModalSubmit={() => {
            setShowModal(false);
          }}
        />

        <AdditionalDetailsWrapper className="first-child">
          <ShimmerPlaceholder
            visible={showShimmer}
            height="2em"
            width="12em"
            marginTop="1em"
          />
          <div className="additional-form-title">
            <Title
              text={`Confirm your Details`}
              visible={!showShimmer}
              clickable={false}
            />
          </div>
          <form className="additional-form">
            {!showShimmer ? (
              <>
                <div className={"check-details-line"}>
                  We fetched the following information from your existing loan
                  records with ABCL. Please verify these details:
                </div>
                <div className="additional-details-card">
                  <span className="heading">Current Address</span>
                  <span>{currentAddress}</span>
                  <div>
                    <span>PinCode</span>
                    <span>{currentPincode}</span>
                  </div>
                  <div>
                    <span>City</span>
                    <span>{currentCity}</span>
                  </div>
                  <div>
                    <span>State</span>
                    <span>{currentState}</span>
                  </div>
                  <div>
                    <span>Mobile Number</span>
                    <span>+91 {mobileNumber}</span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="45px"
                  marginTop="0.5em"
                />
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="180px"
                  marginTop="0.5em"
                />
              </>
            )}
          </form>
          {!showShimmer ? (
            <div className="additional-details-card additional-confirm">
              <div className="sub-title">
                <SubTitle
                  text="Is this your current address?"
                  style={{
                    textAlign: "left",
                    padding: "0px",
                  }}
                />
              </div>
              <form className="radio-buttons">
                <input
                  type="radio"
                  id="additional-yes"
                  name="confirm-additional-detail"
                  checked={additionalConfirm === "Yes"}
                  value={"Yes"}
                  onChange={updateAdditionalConfirm}
                />
                <label for="additional-yes">Yes</label>
                <input
                  type="radio"
                  id="additional-no"
                  name="confirm-additional-detail"
                  checked={additionalConfirm === "No"}
                  value={"No"}
                  onChange={updateAdditionalConfirm}
                />
                <label for="additional-yes">No</label>
              </form>
            </div>
          ) : (
            <>
              <ShimmerPlaceholder
                visible={showShimmer}
                height="50px"
                marginTop="0.5em"
              />
            </>
          )}
          <div className={"additional-form-img bottomDiv"}>
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="3em"
                  width="23em"
                />
              </>
            ) : (
              <>
                <CheckField
                  id="basic-ckeckfield"
                  checked={consentCheckbox}
                  label="By clicking proceed, you agree that the details provided on the screen are correct."
                  style={{
                    fontSize: "15px",
                  }}
                  onClick={() => {
                    setConsentCheckbox(!consentCheckbox);
                  }}
                />
              </>
            )}
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="3em"
                  width="9em"
                />
              </>
            ) : (
              <>
                <Button
                  id="ProceedBtn"
                  className="Btn ProceedBtn"
                  disabled={!allFieldsVerified()}
                  mobile={isMobile}
                  onClick={() => {
                    handleOnSubmit();
                  }}
                  text={"Proceed"}
                />
              </>
            )}
          </div>
        </AdditionalDetailsWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default UpsellVerifyDetails;
